import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

export default class MultipleBarChart extends Component {
    constructor(props) {
      super(props);
      this.state = {
        chartId: this.props.chartId,
        series: this.props.series,
        options: {
          chart: {
            id: this.props.chartId,
            group: this.props.groupId,
            type: 'bar',
            height: this.props.height || 350,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          annotations: {
            yaxis: this.props.yaxis,
            xaxis: this.props.xaxis
          },
          dataLabels: {
            enabled: false
          },
          markers: {
            size: 0,
            style: 'hollow',
          },
          xaxis: {
            categories: this.props.categories,
          },
          fill: {
            opacity: 1
          },
        },
      
      };
    }

  
    render() {
      return (
        


  <div id="chart">
    <div id="chart-multiple-bar">
        <ReactApexChart options={this.state.options} series={this.state.series} type={this.state.options.chart.type} height={this.state.options.chart.height} />
    </div>
</div>
);
}
}
